module.exports = __webpack_public_path__ + "static/media/SunnyBLogoSmall.95bbacc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SunnyBLogoSmall.svg
// module id = 720
// module chunks = 0